import { render, staticRenderFns } from "./MatrizRfmFaixasTable.vue?vue&type=template&id=061964b8&scoped=true&"
import script from "./MatrizRfmFaixasTable.vue?vue&type=script&lang=js&"
export * from "./MatrizRfmFaixasTable.vue?vue&type=script&lang=js&"
import style0 from "./MatrizRfmFaixasTable.vue?vue&type=style&index=0&id=061964b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061964b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
